/* YELASAI — Warenkorb-Spruch fuer die Premium-Produktseiten.
 *
 * Auf den alten Seiten steckte diese Logik in sections/ys-product.liquid.
 * Die Premium-Vorlagen laden diese Section nicht mehr, darum lag der Spruch
 * seit dem Go-live brach. Hier steht er eigenstaendig, damit er nicht wieder
 * an einer Vorlage haengt.
 *
 * Erwartet window.YSP_ADD = {openers:[…], benefits:[…], title:'…'}.
 * Faengt jedes Formular ab, das auf /cart/add zeigt.
 *
 * GTY 23.10.2026: Nach dem Hinzufuegen oeffnet sich wieder der Warenkorb-Drawer
 * des Themes (wie bis 18.07.2026 mit der Theme-Produktseite): Inhalt,
 * Gratisversand-Balken, "Zur Kasse" direkt in den Checkout. Der Spruch steht
 * oben im Drawer, Beacon wie bisher (s = gezeigt, k = Kasse). Gleicher Ablauf
 * wie das Theme selbst (add.js mit sections, dann miniCart.renderContents).
 * Der Hinweis (zeige) bleibt nur als Rueckfall, falls der Drawer fehlt; dort
 * fuehrt "Zur Kasse" jetzt auch direkt in den Checkout, dazu "Warenkorb
 * ansehen" und auf dem Handy (bis 600 px) ein zweizeiliger Aufbau.
 * Die Herkunftsfrage bei Modulen steht im Buchungsformular
 * (snippets/gty-herkunft-buchung.liquid), darum keine Ausnahme fuer Module.
 */
(function () {
  var A = window.YSP_ADD || {};
  var letzter = -1;

  function waehle(liste) {                       // nie zweimal denselben Opener
    if (!liste || !liste.length) return '';
    if (liste.length === 1) return liste[0];
    var i;
    do { i = Math.floor(Math.random() * liste.length); } while (i === letzter);
    letzter = i;
    return liste[i];
  }

  function irgendein(liste) {
    return (liste && liste.length) ? liste[Math.floor(Math.random() * liste.length)] : '';
  }

  function beacon(spruch, ereignis) {
    try {
      navigator.sendBeacon('https://yelasai.ai/spruch_beacon.php',
        new Blob([JSON.stringify({ s: spruch || '(ohne)', e: ereignis })],
                 { type: 'text/plain' }));
    } catch (e) { /* Messung darf den Kauf nie stoeren */ }
  }

  function warenkorbZahl() {
    try {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('.cart-count-bubble span,[data-cart-count],.cart-count')
            .forEach(function (n) { n.textContent = c.item_count; });
        }).catch(function () {});
    } catch (e) {}
  }

  function zeige(name) {
    var alt = document.getElementById('ys-add-ok');
    if (alt) alt.remove();

    // Produktbezogener Spruch nur fuer das Hauptprodukt der Seite.
    // Bei Empfehlungen nennen wir das hinzugefuegte Produkt beim Namen.
    var eigen = !name || name === A.title;
    var spruch = eigen ? irgendein(A.benefits) : (name + ' ist in Ihrem Warenkorb.');
    var kopf = waehle(A.openers) || 'Im Warenkorb';

    // GTY 23.10.2026: Handy zweizeilig (Text oben, Knoepfe volle Breite unten),
    // "Zur Kasse" direkt in den Checkout, darunter "Warenkorb ansehen".
    var handy = window.matchMedia && window.matchMedia('(max-width: 600px)').matches;
    var p = document.createElement('div');
    p.id = 'ys-add-ok';
    p.setAttribute('role', 'status');
    p.setAttribute('aria-live', 'polite');
    p.style.cssText = 'position:fixed;top:18px;left:50%;transform:translateX(-50%);' +
      'z-index:2147481000;background:#4A0D66;color:#F6F1E9;border-radius:14px;' +
      'padding:16px 20px;box-shadow:0 10px 34px rgba(0,0,0,.32);display:flex;' +
      'align-items:center;gap:14px;max-width:92vw;font-size:14.5px;line-height:1.35' +
      (handy ? ';flex-wrap:wrap;align-items:flex-start;width:92vw;box-sizing:border-box;' +
               'padding:14px 16px;gap:12px' : '');
    p.innerHTML =
      '<span style="display:inline-flex;flex:0 0 26px;width:26px;height:26px;border-radius:50%;' +
        'background:#C9A24B;color:#3A2A46;align-items:center;justify-content:center;' +
        'font-weight:700">&#10003;</span>' +
      '<span style="font-weight:600' + (handy ? ';flex:1 1 0;min-width:0' : '') + '">' + kopf +
        (spruch ? '<br><span style="font-weight:400;font-size:13px;opacity:.92;' +
                  'max-width:340px;display:inline-block">' + spruch + '</span>' : '') +
        '<br><a href="/cart" id="ys-add-warenkorb" style="color:#F6F1E9;font-weight:400;' +
          'font-size:13px;text-decoration:underline;opacity:.9">Warenkorb ansehen</a>' +
      '</span>' +
      '<span style="display:flex;gap:10px' + (handy ? ';flex:1 0 100%' : '') + '">' +
      '<a href="/checkout" id="ys-add-kasse" style="background:#C9A24B;color:#3A2A46;' +
        'text-decoration:none;border-radius:9px;padding:9px 14px;font-weight:700;' +
        'white-space:nowrap' + (handy ? ';flex:1 1 0;text-align:center;padding:12px 14px' : '') +
        '">Zur Kasse</a>' +
      '<button type="button" id="ys-add-weiter" style="background:none;' +
        'border:1px solid rgba(246,241,233,.5);color:#F6F1E9;border-radius:9px;' +
        'padding:8px 12px;cursor:pointer;white-space:nowrap' +
        (handy ? ';flex:1 1 0;padding:11px 12px;font-size:14px' : '') +
        '">Weiter einkaufen</button>' +
      '</span>';
    document.body.appendChild(p);

    beacon(spruch, 's');
    var zu = function () { if (p && p.parentNode) p.remove(); };
    var kasse = document.getElementById('ys-add-kasse');
    if (kasse) kasse.addEventListener('click', function () { beacon(spruch, 'k'); });
    var weiter = document.getElementById('ys-add-weiter');
    if (weiter) weiter.addEventListener('click', function () { beacon(spruch, 'w'); zu(); });
    setTimeout(zu, 8000);

    warenkorbZahl();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  // GTY 23.10.2026: Drawer des Themes mit dem Spruch oben drin. false = kein Drawer, dann Hinweis.
  // Beacon k: ein Listener fuer den Kasse-Knopf im Drawer (der Drawer baut seinen Inhalt neu auf).
  var drawerSpruch = null;
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest && e.target.closest('#mini-cart [name="checkout"]');
    if (k && drawerSpruch !== null) { beacon(drawerSpruch, 'k'); drawerSpruch = null; }
  }, true);

  function imDrawer(antwort, name) {
    var mc = document.querySelector('mini-cart');
    if (!mc || typeof mc.renderContents !== 'function' || !antwort || !antwort.sections ||
        !antwort.sections['mini-cart']) return false;
    try { mc.renderContents(antwort); } catch (e) { return false; }

    var eigen = !name || name === A.title;
    var spruch = eigen ? irgendein(A.benefits) : (name + ' ist in Ihrem Warenkorb.');
    var kopf = waehle(A.openers) || 'Im Warenkorb';
    // GTY 26.10.2026: Auf dem Handy (bis 749 px) blendet der Spruch nach 5 Sekunden aus, damit der Inhalt mehr Platz hat (Idee David).
    var ausgeblendet = false, handySpruch = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    function setzen() {
      var ziel = document.querySelector('#mini-cart .mini-cart__main');
      if (ausgeblendet || !ziel || ziel.querySelector('.gty-spruch')) return;
      var b = document.createElement('div');
      b.className = 'gty-spruch';
      b.setAttribute('role', 'status');
      b.style.cssText = 'display:flex;gap:10px;align-items:flex-start;background:#F6F1E9;color:#4A0D66;' +
        'border-radius:10px;padding:12px 14px;margin:0 0 14px;font-size:14px;line-height:1.4;text-align:left';
      b.innerHTML =
        '<span style="flex:0 0 22px;width:22px;height:22px;border-radius:50%;background:#C9A24B;' +
          'color:#3A2A46;display:inline-flex;align-items:center;justify-content:center;' +
          'font-weight:700;font-size:13px">&#10003;</span>' +
        '<span><strong>' + kopf + '</strong>' +
          (spruch ? '<br><span style="font-size:13px;opacity:.85">' + spruch + '</span>' : '') +
        '</span>';
      ziel.insertBefore(b, ziel.firstChild);
    }
    if (handySpruch) setTimeout(function () {
      ausgeblendet = true;
      var b = document.querySelector('#mini-cart .gty-spruch');
      if (!b) return;
      b.style.overflow = 'hidden';
      b.style.maxHeight = b.offsetHeight + 'px';
      b.style.transition = 'opacity .35s ease, max-height .45s ease, margin .45s ease, padding .45s ease';
      void b.offsetHeight;
      requestAnimationFrame(function () { b.style.opacity = '0'; b.style.maxHeight = '0'; b.style.marginBottom = '0'; b.style.paddingTop = '0'; b.style.paddingBottom = '0'; });
      setTimeout(function () { if (b.parentNode) b.remove(); }, 500);
    }, 5000);
    setzen();
    // Beim ersten Oeffnen laedt der Drawer seinen Inhalt nach und ersetzt ihn, dann den Spruch wieder einsetzen
    var mcEl = document.getElementById('mini-cart');
    if (mcEl && window.MutationObserver) {
      var mo = new MutationObserver(setzen);
      mo.observe(mcEl, { childList: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    beacon(spruch, 's');
    drawerSpruch = spruch;
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return true;
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') return;
    var ziel = form.getAttribute('action') || '';
    if (ziel.indexOf('/cart/add') === -1) return;

    ev.preventDefault();
    var knopf = form.querySelector('button[type=submit],button:not([type])');
    var beschriftung = knopf ? knopf.textContent : '';
    if (knopf) { knopf.textContent = 'Wird hinzugefügt …'; knopf.disabled = true; }

    var daten = new FormData(form);                // GTY 23.10.2026: Drawer-Inhalt gleich mitladen
    daten.append('sections', 'mini-cart,cart-icon-bubble');
    daten.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', {
      method: 'POST',
      body: daten,
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (antwort) {
        if (knopf) { knopf.textContent = beschriftung; knopf.disabled = false; }
        var name = form.getAttribute('data-ys-name');
        try { if (!imDrawer(antwort, name)) zeige(name); } catch (e) {}   // liegt schon im Warenkorb, nie doppelt
      })
      .catch(function () { form.submit(); });   // im Zweifel der gewohnte Weg
  }, true);
})();
